/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tame_Still_Skate_ReviveInputs */

const fr_tame_still_skate_revive = /** @type {(inputs: Tame_Still_Skate_ReviveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer le logo`)
};

/**

* @param {Tame_Still_Skate_ReviveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tame_still_skate_revive = /** @type {((inputs?: Tame_Still_Skate_ReviveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tame_Still_Skate_ReviveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tame_still_skate_revive(inputs)
});